
import { useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import Translatable from '../translatable_text/Translatable';
function Header() {
 
  useLayoutEffect(() => {
    const tl = gsap.timeline();
    tl.fromTo('.header', { y: 200 }, { y: 0 }, '+=0.1');
    tl.fromTo(
      '.header .container',
      { opacity: 0, translateY: 40 },
      { opacity: 1, translateY: 0 },
      '-=0'
    );

    // Cleanup function
    return () => {
      tl.kill();
    }
  }, []);
  return (
    <div
      className="header page-header bg-img section-padding"
      data-background="/light/assets/imgs/header/bg1.jpg"
      data-overlay-dark="9"
    >
      <div className="container pt-20X">
        <div className="text-center">
          <h2><Translatable>Login</Translatable>.</h2>
          <div className="mt-15">
            <a href="/" aria-label='go home'><Translatable>Home</Translatable></a>
            <span className="padding-rl-20">|</span>
            <span className="main-color"><Translatable>Authentication</Translatable></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
